import { render, staticRenderFns } from "./EmbeddedSocialMediaReview.vue?vue&type=template&id=911453f6&scoped=true"
import script from "./EmbeddedSocialMediaReview.vue?vue&type=script&lang=js"
export * from "./EmbeddedSocialMediaReview.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedSocialMediaReview.vue?vue&type=style&index=0&id=911453f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911453f6",
  null
  
)

export default component.exports